export default IconHttpQue => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-http-que" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M5 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z" />
  <path d="M6 15l1 1" />
  <path d="M21 8h-4v8h4" />
  <path d="M17 12h2.5" />
  <path d="M10 8v6a2 2 0 1 0 4 0v-6" />
</svg>`;